import { writable } from 'svelte/store';
import "../../server/src/Middleware/Router";
import "./Utils";
function createParamsPath(params = {}) {
    let array = [...Object.entries(params)];
    return array.length === 0 ? '' : '/' + array
        .filter(([name, value]) => value !== null)
        .map(([name, value]) => {
        return encodeURIComponent(name) + '=' + (value !== null ? encodeURIComponent(value.toString()) : '');
    })
        .join('/');
}
function parseParamPath(path) {
    let params = {};
    if (path && path.length > 0) {
        path.substring(1).split('/').map((nameValue) => {
            let [name, value] = nameValue.split('=').map(decodeURIComponent);
            params[name] = value;
        });
    }
    return params;
}
export const routes = [
    { id: "Users", label: "Цілі", mainMenu: true,
        match: /^(users|)$/,
        hash: () => `users` },
    { id: "UserChats", label: "Чати", mainMenu: false,
        match: /^user\/(?<userId>[0-9]+)\/chats(\/(?<chat_id>[0-9]+))?$/,
        hash: (userId, chat_id = null) => `user/${userId}/chats${chat_id ? '/' + chat_id : ''}`,
    },
    { id: "UserContacts", label: "Контакти", mainMenu: false,
        match: /^user\/(?<userId>[0-9]+)\/contacts(?<filters>\/.*?)?$/,
        hash: (userId, filters = {}) => {
            return `user/${userId}/contacts${createParamsPath(filters)}`;
        },
        paramsParser: (params) => Object.assign(params, parseParamPath(params.filters), { filters: null }),
    },
    { id: "UserName", label: "Імена цілі", mainMenu: false,
        match: /^user_name\/(?<userNameId>[0-9]+)$/,
        hash: (userNameId) => `user_name/${userNameId}` },
    { id: "User", label: "Ціль", mainMenu: false,
        match: /^user\/(?<userId>[0-9]+)$/,
        hash: (userId) => `user/${userId}` },
    { id: "Contact", label: "Контакт", mainMenu: false,
        match: /^contact(?<filters>\/.*?)$/,
        hash: (telegram_id, phone) => {
            return `contact${createParamsPath({ telegram_id, phone })}`;
        },
        paramsParser: (params) => Object.assign(params, parseParamPath(params.filters), { filters: null }),
    },
    { id: "AddUser", label: "Додавання цілей", mainMenu: true,
        match: /^addUser$/,
        hash: () => `addUser` },
    { id: "UserContactsSearch", label: "Пошук по контактах", mainMenu: true,
        match: /^userContactsSearch$/,
        hash: () => `userContactsSearch` },
    { id: "UserMessageSearch", label: "Пошук по повідомленнях", mainMenu: true,
        match: /^userMessageSearch$/,
        hash: () => `userMessageSearch` },
    { id: "SearchNearAddTask", label: "Додати гео пошук", mainMenu: true,
        match: /^searchNearAddTask$/,
        hash: () => `searchNearAddTask` },
    { id: "SearchNearTaskList", label: "Список пошуків по гео", mainMenu: true,
        match: /^searchNearTaskList$/,
        hash: () => `searchNearTaskList` },
    { id: "SearchNearTask", label: "Гео Пошук", mainMenu: false,
        match: /^searchNearTask\/(?<taskId>[0-9]+)$/,
        hash: (taskId) => `searchNearTask/${taskId}` },
    { id: "AppList", label: "Розсильники", mainMenu: true,
        match: /^appList$/,
        hash: () => `appList` },
    { id: "BotList", label: "Боти", mainMenu: true,
        match: /^botList$/,
        hash: () => `botList` },
    { id: "ExportUserList", label: "Експорт", mainMenu: true,
        match: /^exportUserList$/,
        hash: () => `exportUserList` },
    { id: "QrLogin", label: "QR Авторизація", mainMenu: true,
        match: /^qrLogin$/,
        hash: () => `qrLogin` },
    // {id: "Graph", label: "Спільні контакти", mainMenu: true,
    //     match: /^users_graph$/,
    //     hash:()=>`users_graph`},
];
export function getRouteById(id) {
    for (let item of routes) {
        if (item.id === id) {
            return item;
        }
    }
}
export const route = writable(null);
window.addEventListener('hashchange', ({ newURL, oldURL }) => {
    let hash = newURL.split('#').slice(1).join('#');
    openPage(hash);
});
function openPage(hash) {
    for (let item of routes) {
        let match = item.match.exec(hash);
        if (match) {
            route.set({
                id: item.id,
                label: item.label,
                match: item.match,
                params: item.paramsParser ? item.paramsParser(match.groups) : match.groups,
            });
            return;
        }
    }
    alert("Ця сторінка ще не реалізована");
}
openPage(location.hash.slice(1));
